function view (path) {
  return () => import(/* webpackChunkName: '' */ '@/views/user/' + path).then(m => m.default || m) // eslint-disable-line prefer-template
}

const userRoutes = [
  {
    path: '/user/dashboard',
    component: view('Dashboard'),
    name: 'user.dashboard',
    meta: {
      breadcrumb: [
        {
          text: 'Home'
        },
        {
          text: 'Dashboard',
          active: true
        }
      ]
    }
  },
  {
    path: '/user/vouchers',
    component: view('Vouchers'),
    name: 'user.vouchers',
    meta: {
      breadcrumb: [
        {
          text: 'Home'
        },
        {
          text: 'Vouchers',
          active: true
        }
      ]
    }
  }
]

export default userRoutes
